<div class="SLV2-icn-subject-box {{subjectNameWithoutSpace | lowercase}}">
    <div class="SLV2-icn-box" [ngClass]="{'noicon' : getSubjectIconName(subjectNameWithoutSpace) == 'selflearnv2-ui/assets/img/subject-icons/default_subject_icon'}">
        <img [src]="getSubjectIcon(subjectNameWithoutSpace)" />
    </div>
    <h4 class="SLV2-icn-subject-title">{{subjectName}}</h4>
</div>
